<template>
  <div :style="[bannerContainerCss,{'background':backgroundColor, 'background':backgroundGradient}]">
    <brave-link v-if="link" is-external :to="link">
      <img :src="(this.$isMobile() && bannerMobile) ? bannerMobile: banner" :style="bannerCss">
    </brave-link>
    <img v-else :src="(this.$isMobile() && bannerMobile) ? bannerMobile: banner" :style="bannerCss">
  </div>
</template>

<script>
export default {
  name: "promo-advertisement",
  props: [
    'banner',
    'banner-mobile',
    'backgroundColor',
    'backgroundGradient',
    'link'
  ],
  computed: {
    bannerContainerCss() {
      return {
        'text-align':'center',
        'z-index': 2,
        'margin-bottom': this.$isMobile() ? '1em':'',
        'margin-top': this.$isMobile() ? '-5em':''
      }
    },
    bannerCss() {
      return {
        'margin-top': this.$isMobile() ? '-30px' : '',
        'padding': this.$isMobile() ? '20px 20px' : '10px 0',
        'transform': this.$isMobile() ? 'scale(1.05)' : ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/promo-advertisement.vue